<div fxLayoutAlign="center center">
  <button mat-raised-button color="warn"
          (click)="deleteView()" class="btn-delete-playground">
    {{'GENERAL.DELETE' | translate}}
  </button>

</div>
